import type { ReactNode } from 'react';
import { Button } from 'app/design/primitives/button';
import { Box, Row, Text } from 'app/shopify';
import type { TutorialRef } from 'app/types/tutorial';
import { useTutorialRef } from 'app/components/tutorial-overlay';
import { View } from 'react-native';

export interface DesktopProfileMenuItemProps {
  destructive?: boolean;
  icon: ReactNode;
  label: string;
  loading?: boolean;
  onPress: () => void;
  tutorialRef?: TutorialRef;
}

export function DesktopProfileMenuItem({
  destructive,
  icon,
  label,
  loading,
  onPress,
  tutorialRef,
}: DesktopProfileMenuItemProps) {
  const { viewRef } = useTutorialRef(tutorialRef);

  return (
    <View ref={viewRef} collapsable={false}>
      <Button
        justifyContent="flex-start"
        disabled={loading}
        marginHorizontal="spacing.general.x1"
        paddingHorizontal="spacing.general.x3"
        paddingVertical="spacing.general.x3"
        onPress={onPress}
        style={{ borderRadius: 10 }}
      >
        <Row alignItems="center" gap="spacing.general.x3">
          <Box alignItems="center" height={22} justifyContent="center" width={22}>
            {icon}
          </Box>
          <Text flex={1} color={destructive ? 'text.error' : 'text.primary'} fontSize={14} fontWeight="600">
            {label}
          </Text>
        </Row>
      </Button>
    </View>
  );
}
